import script from "./TraningTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TraningTabs.vue?vue&type=script&setup=true&lang=js"

import "./TraningTabs.vue?vue&type=style&index=0&id=98eace3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98eace3e"]])

export default __exports__